import React, { useState } from 'react';
import { StarIcon, ArrowLeftIcon, ArrowRightIcon, ExternalLinkIcon } from 'lucide-react';
import { Norden } from './Norden';

// Vul hier de URL van het Google Bedrijfsprofiel in.
// Zolang dit leeg is, wordt de knop naar Google niet getoond.
const GOOGLE_REVIEWS_URL = '';
type Review = {
  name: string;
  company: string;
  rating: number;
  text: string;
  source: 'google' | 'direct';
};

// LET OP, CONTROLEER DIT VOOR DE SITE ECHT LIVE GAAT
// De reviews met source 'google' zijn overgenomen uit het Google
// Bedrijfsprofiel. Ze zijn daar door Google naar het Engels vertaald en
// hier weer naar het Nederlands teruggezet. De strekking klopt, maar de
// bewoording kan afwijken van wat de klant oorspronkelijk schreef.
// Leg ze naast de Nederlandse originelen in je Bedrijfsprofiel en pas aan
// waar nodig. Een review is een citaat, dus die moet woordelijk kloppen.
const reviews: Review[] = [{
  name: 'toucan man',
  company: 'Ondernemer',
  rating: 5,
  text: 'Toppers, ze hebben in no time een website voor me opgezet. Ik ben al een tijd ondernemer en heb met veel marketing- en websitebureaus gewerkt, maar dit is in alle opzichten de beste.',
  source: 'google'
}, {
  name: 'Familie Wienema',
  company: 'Google review',
  rating: 5,
  text: 'Uitstekende service en resultaat. Dit bedrijf heeft niet alleen de vindbaarheid van mijn website in zoekmachines verbeterd, maar hem ook voorzien van een strak en professioneel ontwerp.',
  source: 'google'
}, {
  name: 'Jayden',
  company: 'Eigenaar webshop',
  rating: 5,
  text: 'Nadat ik bij een ander bedrijf een website voor mijn webshop had laten bouwen ging het compleet mis. Ik moest veel betalen en kreeg weinig resultaat. Toen raadde een vriend Noord Digital aan, en wat een verschil.',
  source: 'google'
}, {
  name: 'Leonie Tieken',
  company: 'Google review',
  rating: 5,
  text: 'Nadat ik door een ander bedrijf was opgelicht hebben deze jongens mij enorm goed geholpen met een prachtige website. Ik ben er zo dankbaar voor.',
  source: 'google'
}, {
  name: 'Mats Steenhuis',
  company: 'Eigenaar SteenhuisVisuals',
  rating: 5,
  text: 'Ik heb door deze jongens een website laten maken voor mijn nieuwe bedrijf. Na snelle communicatie kwamen zij al snel tot een concept, dit sloeg direct aan waarna wij in zee zijn gegaan met elkaar. Als eindresultaat een prachtige website. 5 van de 5 sterren.',
  source: 'google'
}, {
  name: 'Carla van Hilten-Deuzeman',
  company: 'Eigenaar metcarla.nl',
  rating: 5,
  text: 'Superblij ben ik met mijn website. Wat begon als een droom, krijgt nu gestalte. Samen met Noord Digital hebben we gebrainstormd, nagedacht, geschaafd en geschreven om een website te maken die uitstraalt wie ik ben. Snel schakelen, meedenken, vriendelijk en gewoon heel erg aardig. Ik kan ze van harte aanbevelen.',
  source: 'direct'
}, {
  name: 'Justin Nijholt',
  company: 'Google review',
  rating: 5,
  text: 'Uiterst tevreden met het resultaat. Ze dachten proactief mee en leverden een professionele website op. Snelle communicatie, duidelijke afspraken en topkwaliteit. Een aanrader.',
  source: 'google'
}, {
  name: 'Werner Tausendfreund',
  company: 'Google review',
  rating: 5,
  text: 'Ik ben uitstekend geholpen. Ze luisteren goed naar onze wensen en komen met goede, professionele oplossingen. Supervriendelijk en ze reageren snel.',
  source: 'google'
}, {
  name: 'Akin Yucel',
  company: 'Google review',
  rating: 5,
  text: 'Erg blij met mijn nieuwe website. Goede communicatie, snel werk en het resultaat ziet er professioneel uit. Ik raad het zeker aan aan iedereen die een website wil laten bouwen.',
  source: 'google'
}, {
  name: 'Nicola de Roode',
  company: 'Eigenaar AS Family Fitness Center B.V.',
  rating: 5,
  text: 'Het is zo fijn om te weten dat een website in goede handen is. Korte lijnen, prettig contact, technisch sterk en persoonlijk betrokken. Wat voelt als een verlengstuk van ons team, een aanrader!',
  source: 'direct'
}, {
  name: 'Sanne-Isabelle Beekhuis',
  company: 'Google review',
  rating: 5,
  text: 'SUPER ervaring met Noord Digital. Ontzettend professioneel. Goede communicatie, snelle service en een prachtig resultaat.',
  source: 'google'
}, {
  name: 'Floris Holscher',
  company: 'Google review',
  rating: 5,
  text: 'Een jong en gedreven team dat mooie websites maakt, van klein en simpel tot mooi en zeer complex. Hier ben je aan het juiste adres.',
  source: 'google'
}, {
  name: 'Jovanna Vriend',
  company: 'Google review',
  rating: 5,
  text: 'Heel duidelijk en behulpzaam, uitstekende service. Ze bellen je direct terug.',
  source: 'google'
}, {
  name: 'Jens Wiegers',
  company: 'Eigenaar Wiegers Iconic Nutrition',
  rating: 5,
  text: 'De samenwerking met Noord was vanaf het begin al erg prettig. Ze luisterden goed naar mijn wensen, communiceerden duidelijk en stonden altijd open voor feedback. Het eindresultaat is precies wat ik voor ogen had: een website die past bij mijn merk en doelgroep.',
  source: 'direct'
}, {
  name: 'Mano Coolegem',
  company: 'Google review',
  rating: 5,
  text: 'Supervriendelijk en snel. Ze leveren fantastisch werk, denken proactief mee en geven bruikbare tips.',
  source: 'google'
}, {
  name: 'Michiel Bakker',
  company: 'Google review',
  rating: 5,
  text: 'Een jong, enthousiast team. Ze denken proactief mee en komen hun afspraken na.',
  source: 'google'
}, {
  name: "Tommy's Services & Security",
  company: 'Eigenaar',
  rating: 5,
  text: 'Erg blij met de website die ze voor mij hebben gemaakt.',
  source: 'google'
}, {
  name: 'Basar Yuksel',
  company: 'Mede-eigenaar Common Frame Media',
  rating: 5,
  text: 'We are absolutely delighted with our new website. The design fits our wishes perfectly, adjustments were made quickly and communication was always clear and friendly. A great collaboration with an excellent result, highly recommended!',
  source: 'direct'
}, {
  name: 'Nico van Diemen',
  company: 'Google review',
  rating: 5,
  text: 'Aardige en professionele heren. Ze geven helder advies en leveren mooi werk.',
  source: 'google'
}, {
  name: 'Michel Kossen',
  company: 'Google review',
  rating: 5,
  text: 'Een club jonge ondernemers met een moderne en frisse kijk op zakendoen. Een aanrader.',
  source: 'google'
}, {
  name: 'Percy Stoffelen',
  company: 'Google review',
  rating: 5,
  text: 'Ze weten waar ze mee bezig zijn. Altijd vriendelijk en ontzettend behulpzaam.',
  source: 'google'
}, {
  name: 'Pim Dekker',
  company: 'Eigenaar Jaepie-Jaepie',
  rating: 5,
  text: 'Goede service! Snel en makkelijk contact en altijd zo geregeld. Meedenken in oplossingen, ik hou er van!',
  source: 'direct'
}, {
  name: 'Tom Brans',
  company: 'Google review',
  rating: 5,
  text: 'Wat een vriendelijke en professionele club. Hebben mij heel goed geholpen met een paar kleine dingen.',
  source: 'google'
}, {
  name: 'defne akar',
  company: 'Google review',
  rating: 5,
  text: 'It was a pleasure working with the Noord Digital team. They brought our vision into life.',
  source: 'google'
}, {
  name: 'ramona pepping',
  company: 'Google review',
  rating: 5,
  text: 'Vriendelijk en kundig team.',
  source: 'google'
}, {
  name: 'Aiden Floris',
  company: 'Google review',
  rating: 5,
  text: 'Goed geholpen door de jongens van Noord Digital. Bedankt voor de tips.',
  source: 'google'
}];
const PER_PAGE = 2;
export const Reviews: React.FC = () => {
  const [page, setPage] = useState(0);
  const totalPages = Math.max(1, Math.ceil(reviews.length / PER_PAGE));
  const visibleReviews = reviews.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);
  const nextPage = () => setPage(p => (p + 1) % totalPages);
  const prevPage = () => setPage(p => (p - 1 + totalPages) % totalPages);
  return <div className="w-full bg-white py-16 md:py-[60px]" data-id="element-716" data-mp="1pobn7mvjzxc7">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-717" data-mp="35zfn93yzqo8d">
        <div className="max-w-3xl mx-auto text-center mb-6" data-id="element-718" data-mp="311xa11dxxmuk">
          <h2 className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-719" data-mp="313i7ozvjxlwn">
            Wat onze klanten zeggen
          </h2>
          <p className="text-[#6B7280] mb-6 leading-relaxed text-lg" data-id="element-720" data-mp="13djxfuqa0239">
            Van lokale vakmensen tot zorgpraktijken en uitzendbureaus. Onze
            klanten waarderen de korte lijnen, de eerlijke communicatie en het
            feit dat er iemand opneemt als je belt. Lees hieronder wat zij over
            hun ervaring te vertellen hebben.
          </p>
          <div className="relative inline-block" data-id="element-721" data-mp="1i4sjjtuyz5bn">
            <Norden variant="speechBubble" bubbleText="Onze klanten aan het woord" className="mb-8" data-id="element-722" data-mp="1m3jkkc2k3741" />
          </div>
        </div>

        <div className="relative" data-id="element-723" data-mp="1r3xlzb9njit3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 items-stretch" data-id="element-724" data-mp="1w2h3mzh7q8fn">
            {visibleReviews.map((review, index) => <figure key={`${page}-${index}`} className="bg-white rounded-2xl shadow-[0_8px_16px_rgba(0,0,0,0.08)] border border-gray-100 p-6 flex flex-col" data-id="element-725" data-mp="3svke5g5a5jr5" data-mpi={index}>
                <div className="flex items-center justify-between mb-3" data-id="element-726" data-mp="1qaue67vq1pz">
                  <div className="flex" aria-label={`${review.rating} van de 5 sterren`} data-id="element-727" data-mp="3qbw623zf25hz">
                    {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-yellow-400 fill-current" aria-hidden="true" data-id="element-728" data-mp="3gkjab1ahyv6o" data-mpi={i} />)}
                  </div>
                  {review.source === 'google' && <span className="text-xs font-medium text-[#6B7280] bg-[#F7F8FA] border border-gray-200 rounded-full px-2.5 py-1" data-id="element-729" data-mp="3bmzye819uuhw">
                      via Google
                    </span>}
                </div>
                <blockquote className="text-[#6B7280] mb-4 italic flex-grow text-base leading-relaxed" data-id="element-730" data-mp="82n5c6unvyn0">
                  {review.text}
                </blockquote>
                <figcaption className="mt-auto pt-4 border-t border-gray-100" data-id="element-731" data-mp="3uawldcioqq08">
                  <p className="font-bold text-[#111827]" data-id="element-732" data-mp="2nwdrwl6x1ia0">{review.name}</p>
                  <p className="text-sm text-[#6B7280]" data-id="element-733" data-mp="2iwrdw9j9jy05">{review.company}</p>
                </figcaption>
              </figure>)}
          </div>

          {totalPages > 1 && <div className="flex justify-center items-center gap-4 mt-6" data-id="element-734" data-mp="e5ygyw7gzkcw">
              <button onClick={prevPage} className="p-2 rounded-full bg-[#F7F8FA] hover:bg-[#007AFF] hover:text-white transition-colors flex-shrink-0" aria-label="Vorige reviews" data-id="element-735" data-mp="97djh4jlres5">
                <ArrowLeftIcon className="h-5 w-5" data-id="element-736" data-mp="j400tjcpznpf" />
              </button>

              <p className="text-sm text-[#6B7280] tabular-nums" data-id="element-737" data-mp="wvwrdiyqppjp">
                {page + 1} van {totalPages}
              </p>

              <button onClick={nextPage} className="p-2 rounded-full bg-[#F7F8FA] hover:bg-[#007AFF] hover:text-white transition-colors flex-shrink-0" aria-label="Volgende reviews" data-id="element-738" data-mp="sv33gplasaqt">
                <ArrowRightIcon className="h-5 w-5" data-id="element-739" data-mp="11v9em4tiwymt" />
              </button>
            </div>}

          <div className="flex flex-wrap justify-center gap-4 mt-10" data-id="element-740" data-mp="38l7h0ljczc3m">
            {GOOGLE_REVIEWS_URL && <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-white border-2 border-[#007AFF] text-[#007AFF] hover:bg-[#007AFF] hover:text-white font-medium py-3 px-6 rounded-xl transition duration-300" data-id="element-741" data-mp="33mcq0wb8mh8f">
                Lees alle reviews op Google
                <ExternalLinkIcon className="h-4 w-4 ml-2" data-id="element-742" data-mp="19esavcrs2odc" />
              </a>}
            <a href="/#client-cases" className="inline-flex items-center bg-[#007AFF] hover:bg-[#005FCC] text-white font-medium py-3 px-6 rounded-xl transition duration-300" data-id="element-743" data-mp="19coa33p6e5ha">
              Bekijk onze klantcases
              <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-744" data-mp="15cxacaho8f0m" />
            </a>
          </div>
        </div>
      </div>
    </div>;
};